module.exports = __webpack_public_path__ + "img/logo-small.265e9a07.svg";